import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IsbnDescriptionService} from './isbn-description.service';
import {environment} from '../../environments/environment';
import {AppConfigService} from '../config/app-config.service';
import {DomSanitizer} from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-isbn-description',
  templateUrl: './isbn-description.component.html',
  styleUrls: ['./isbn-description.component.scss']
})

export class IsbnDescriptionComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() isbnIds: any;
  @Input() maxChar: number;
  @Input() header = false;
  maxCharLenght: number;
  text: string;
  config = this.appConfig.isbnDescriptionConfig;
  shouldLoad: BehaviorSubject<boolean>;
  showMore = false;

  constructor(private service: IsbnDescriptionService, public appConfig: AppConfigService, public dom: DomSanitizer) {
    this.shouldLoad = new BehaviorSubject<boolean>(false);
  }
  ngOnInit(): void {
    this.maxCharLenght = this.maxChar ? this.maxChar : this.config[this.type].maxChar;
    this.subscribeToLoad();
  }

  ngOnDestroy(): void {
    this.shouldLoad.unsubscribe();
  }

  subscribeToLoad() {
    this.shouldLoad.asObservable().subscribe((value) => {
      if (value && this.config[this.type].active && (this.type && this.isbnIds) && this.isbnIds.length > 0) {
        this.loadData(this.isbnIds);
      }
    });
  }

  loadData(isbn) {
    this.service.getDesc(isbn).subscribe(data => {
      data ? this.prepareData(data) : null;
    });
  }

  prepareData(data) {
    this.text = data.text;
  }


}
